import { connect } from "react-redux";
import Pin from "../../components/card/Pin";
import {
  setTimer,
  callGoogleAnalytics,
  setFocus,
  logout,
  setIsCalProvider,
  Stages,
  setStage,
  callGoogleAnalyticsEvent,
} from "../../actions/actions";

let halftimeSent = false;
const mapDispatchToProps = (dispatch) => {
  return {
    onLogout: () => {
      dispatch(setIsCalProvider(window.isCalProvider));
      return dispatch(logout());
    },
    setFocus: (refName) => {
      dispatch(setFocus(refName));
    },
    onTimerChange: (percent, time) => {
      if (percent % 10 == 50 && !halftimeSent) {
        dispatch(
          callGoogleAnalytics(window.settings.ga.pages.pinTimerHalftime)
        );
        halftimeSent = true;
      }
      return dispatch(setTimer(percent, time));
    },
    onTimerEnded: () => {
      dispatch(callGoogleAnalytics(window.settings.ga.pages.pinTimerEnded));
    },
    redirect: (page) => {
      if (page === "cards") {
        dispatch(
          callGoogleAnalyticsEvent(
            "online-secret-code",
            "show-code-success",
            "view-another-card"
          )
        );
      } else {
        dispatch(
          callGoogleAnalyticsEvent(
            "online-secret-code",
            "show-code-success",
            "next"
          )
        );
      }

      dispatch(setStage(Stages[page]));
    },
  };
};

const mapStateToProps = (state) => {
  return {
    pin: state.session.card.pin,
    error: state.session.app.error,
    timeout: window.settings.timeout,
    time: state.session.card.time,
    percent: state.session.card.percent,
    isCalProvider: state.session.app.isCalProvider,
    cards: state.session.card.cards,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Pin);



// WEBPACK FOOTER //
// ./src/containers/card/Pin.js